export default __webpack_public_path__ + "static/media/nav-arrow-down.84359758.svg";